import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  constructor(private httpClient: HttpClient) { }

  public getVersion(): Observable<string> {
    const url = 'api/version';
    return this.httpClient.get<string>(url);
  }

  public getServerNowTime(): Observable<string> {
    const url = 'api/version/server-now-time';
    return this.httpClient.get<string>(url);
  }
}
